export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-pagination/es/index.js
// module id = 865
// module chunks = 0